import styled from "styled-components";
import { Card } from "react-bootstrap";
import { ReactComponent as GeoLocationIcon } from "../../../../../assets/svgs/geo-alt-fill.svg";
import { ReactComponent as TelephoneFillIcon } from "../../../../../assets/svgs/telephone-fill.svg";
import { ReactComponent as ClockFillIcon } from "../../../../../assets/svgs/clock-fill.svg";
import { ReactComponent as SearchIcon } from "../../../../../assets/svgs/search.svg";
import { ReactComponent as BusIcon } from "../../../../../assets/svgs/bus.svg";
import { css } from "styled-components/macro";
import { PRIMARY_COLORS } from "../../../../consts/colors";



export const StyledAppointmentLocationCard = styled(Card)`
   display: flex;
   padding: 30px;
   transition: all 0.3s;
   border-color: ${PRIMARY_COLORS.NEBULA};
   border-width: 1px;
   background-color: #f6f6f7;
   @media (max-width: 720px) {
      padding: 20px;
   }
`;

export const AppointmentCardHeaderDiv = styled.div`
   display: flex;
   gap: 10px;
   align-items: center;

   img {
      width: 20px;
      height: auto;
      flex-shrink: 0;
      margin-bottom: 5px;
   }
`;

export const PhoneNumberSpan = styled.span`
   letter-spacing: 1px;
   font-size: 13px!important;
`;

const baseIconStyles = css`
   width: 7px;
   height: 7px;
   fill: gray;
`;

export const StyledBusIcon = styled(BusIcon)`
   width: 20px;
   height: 20px;
   fill: ${PRIMARY_COLORS.CLOUDY_GREY};
`;

export const StyledTelephoneIcon = styled(TelephoneFillIcon)`
   ${baseIconStyles}
`;

export const StyledGeoLocation = styled(GeoLocationIcon)`
   ${baseIconStyles}
`;

export const StyledClockIcon = styled(ClockFillIcon)`
   ${baseIconStyles}
`;

export const StyledSearchIcon = styled(SearchIcon)`
   margin-left: 10px;
`;

export const Title = styled.h5`
   font-size: 17px;
   font-weight: bold;
   font-family: "Roboto", "Helvetica Neue", sans-serif !important;
   color: ${PRIMARY_COLORS.DAVY_GREY};
`;

export const Body = styled("div")`
   font-family: "Roboto", "Helvetica Neue", sans-serif !important;
   margin-top: 14px;
   font-size: 13px;
   &.mobile-css {
      display: flex;
      flex-direction: column;
      gap: 3px;
     
   }
   &.desktop-css {
      display: flex;
      align-items: flex-end;
   }
   svg {
      scale: 1.8;
      margin-right: 10px;
   }
   .align-center-items {
      display: flex;
      align-items: center;
   }
   .location-clock-mobile-css {
      display: flex;
      justify-content: space-between;
   }
`;

export const Header = styled("div")`
   display: flex;
   justify-content: space-between;
   align-items: center;

   .visit-page-css {
      text-decoration: none;
      color: black;
      font-size: 13px;
   }
`;

export const Footer = styled("div")`
   display: flex;
   flex-direction: column;
   gap: 25px;
   &.desktop-css {
      align-items: flex-end;
   }
   font-size: 13px;
   margin-top: 15px;
   .visit-page-css {
      text-decoration: none;
      color: black;
   }
   
`;
